import { client } from '../http';

export default {
  async disableBoti(reason) {
    return await client.post('/api/boti/state/auto-send', { on: false, reason });
  },

  async enableBoti() {
    return await client.post('/api/boti/state/auto-send', { on: true });
  },
};
